import { createComponent, logError } from '@/shared'
import { getProductRatings } from '@/api/productReviews'
import RatingWithCounter from '@/components/RatingWithCounter'

const getProductIdsFromDom = () => {
  return Array
    .from(document.querySelectorAll('.js-dbs-products-reviews--product-list-product'))
    .map(element => element.getAttribute('data-productId'))
}

export function renderProductsListRatings () {
  getProductRatings(getProductIdsFromDom())
    .then(ratings => {
      ratings.forEach(function (rating) {
        const selector = ['.js-dbs-products-reviews--product-list-product[data-productid="', rating.id, '"]'].join('')
        let querySelector = document.querySelectorAll(selector)
        querySelector.forEach(item => {
          createComponent(item, RatingWithCounter, {
            rating: rating.rating,
            count: rating.count
          })
        })
      })
    })
    .catch(logError)
}



// WEBPACK FOOTER //
// ./src/modules/renderProductsListRatings.js